import React from 'react';
import { formatCurrency } from '../../utils/calculations';
interface TotalsPanelProps {
  subtotal: number;
  taxAmount: number;
  taxRate: number;
  taxLabel?: string;
  shippingCharge?: number;
  discount?: number;
  fee?: number;
  feeLabel?: string;
  total: number;
}
export function TotalsPanel({
  subtotal,
  taxAmount,
  taxRate,
  taxLabel,
  shippingCharge = 0,
  discount = 0,
  fee = 0,
  feeLabel,
  total
}: TotalsPanelProps) {
  // Default tax label: "Tax (X%)" or just "Tax" if rate is 0
  const displayTaxLabel = taxLabel || (taxRate > 0 ? `Tax (${(taxRate * 100).toFixed(0)}%)` : 'Tax');
  // Default fee label
  const displayFeeLabel = feeLabel || 'Fee';
  return <div className="bg-gray-50 rounded-lg p-4 space-y-2" data-id="element-228">
      <div className="flex justify-between text-sm" data-id="element-229">
        <span className="text-gray-600" data-id="element-230">Subtotal</span>
        <span className="font-medium text-gray-900" data-id="element-231">
          {formatCurrency(subtotal)}
        </span>
      </div>

      {shippingCharge > 0 && <div className="flex justify-between text-sm" data-id="element-232">
          <span className="text-gray-600" data-id="element-233">Shipping</span>
          <span className="font-medium text-gray-900" data-id="element-234">
            {formatCurrency(shippingCharge)}
          </span>
        </div>}

      {taxAmount > 0 && <div className="flex justify-between text-sm" data-id="element-235">
          <span className="text-gray-600" data-id="element-236">{displayTaxLabel}</span>
          <span className="font-medium text-gray-900" data-id="element-237">
            {formatCurrency(taxAmount)}
          </span>
        </div>}

      {fee > 0 && <div className="flex justify-between text-sm" data-id="element-238">
          <span className="text-gray-600" data-id="element-239">{displayFeeLabel}</span>
          <span className="font-medium text-gray-900" data-id="element-240">
            {formatCurrency(fee)}
          </span>
        </div>}

      {discount > 0 && <div className="flex justify-between text-sm" data-id="element-241">
          <span className="text-gray-600" data-id="element-242">Discount</span>
          <span className="font-medium text-green-600" data-id="element-243">
            -{formatCurrency(discount)}
          </span>
        </div>}

      <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-244">
        <div className="flex justify-between" data-id="element-245">
          <span className="text-base font-semibold text-gray-900" data-id="element-246">Total</span>
          <span className="text-base font-bold text-gray-900" data-id="element-247">
            {formatCurrency(total)}
          </span>
        </div>
      </div>
    </div>;
}